import React from "react";
import { Card, Statistic } from "antd";
import {
  MessageOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

interface StatsBarProps {
  totalMessages: number;
  uptimeSeconds: number | null;
  connectedAt: string | null;
}

function formatUptime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

function formatConnectedAt(iso: string): string {
  return new Date(iso).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const StatsBar = ({ totalMessages, uptimeSeconds, connectedAt }: StatsBarProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-4">
      <Card bordered={false} className="bg-white rounded-lg border border-gray-200 flex-1">
        <Statistic
          title="Messages Handled"
          value={totalMessages}
          prefix={<MessageOutlined className="text-blue-500" />}
        />
      </Card>

      <Card bordered={false} className="bg-white rounded-lg border border-gray-200 flex-1">
        <Statistic
          title="Session Uptime"
          value={uptimeSeconds !== null ? formatUptime(uptimeSeconds) : "—"}
          prefix={<ClockCircleOutlined className="text-green-500" />}
        />
      </Card>

      <Card bordered={false} className="bg-white rounded-lg border border-gray-200 flex-1">
        <Statistic
          title="Connected Since"
          value={connectedAt ? formatConnectedAt(connectedAt) : "—"}
          prefix={<CalendarOutlined className="text-purple-500" />}
          valueStyle={{ fontSize: 16 }}
        />
      </Card>
    </div>
  );
};
